import React, { useEffect, useState } from 'react';
const NAMES = ['María', 'Laura', 'Carolina', 'Alejandra', 'Gabriela', 'Luciana', 'Valeria', 'Daniela', 'Marcela', 'Patricia', 'Silvia', 'Andrea', 'Claudia', 'Romina', 'Verónica', 'Natalia', 'Florencia', 'Soledad', 'Cecilia', 'Mariana'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Corrientes', 'San Juan', 'Jujuy', 'Paraná', 'Resistencia', 'San Luis', 'Formosa', 'Santiago del Estero'];
const PRODUCTS = [{
  name: 'Pack Completo',
  emoji: '🏆'
}, {
  name: 'Pack Primaria',
  emoji: '📘'
}, {
  name: 'Pack Secundaria',
  emoji: '📗'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2; // 2 to 15 minutes
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      // Hide after 4 seconds
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        // Show next after 5 seconds of being hidden
        showTimeout = setTimeout(cycleNotification, 5000);
      }, 4000);
    };
    // Initial delay of 8 seconds before first notification
    const initialTimeout = setTimeout(cycleNotification, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-163">
      <div className="bg-[#0d0800] border border-[#FF6B00]/40 rounded-xl shadow-2xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-164">
        {/* Close Button */}
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors p-1" aria-label="Cerrar notificación" data-id="element-165">
          ✕
        </button>

        {/* Verified Badge */}
        <div className="flex items-center gap-2 mb-2" data-id="element-166">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-167" />
          <span className="text-green-400 text-xs font-bold uppercase tracking-wider" data-id="element-168">
            Compra verificada
          </span>
        </div>

        {/* Content */}
        <p className="text-white text-sm mb-1" data-id="element-169">
          <span className="font-bold" data-id="element-170">
            {notification.name} {notification.initial}.
          </span>{' '}
          de {notification.city}
        </p>
        <p className="text-gray-300 text-sm mb-2" data-id="element-171">
          compró{' '}
          <span className="text-[#FF6B00] font-bold" data-id="element-172">
            {notification.product.name} {notification.product.emoji}
          </span>
        </p>

        {/* Time */}
        <p className="text-gray-500 text-xs" data-id="element-173">
          hace {notification.timeAgo} minutos
        </p>
      </div>
    </div>;
}